import Vue, { FunctionalComponentOptions, CreateElement, RenderContext } from 'vue';

export default <FunctionalComponentOptions>{
    name: 'WokStatsCard',
    
    functional: true,

    props: {
        icon: {
            type: String,
            default: undefined
        },
        title: {
            type: String,
            required: true
        },
        value: {
            type: [String, Number],
            required: true
        },
        fromValue: {
            type: [String, Number],
            required: undefined
        },
        trendValue: {
            type: [String, Number],
            default: undefined
        },
        trend: {
            type: String,
            default: '',
            validator: (v: string) => v == '' || /(increasing|decreasing)/.test(v)
        }
    },

    render: function(h: CreateElement, ctx: RenderContext) {
        let hasFromValue = ctx.props.fromValue != null || ctx.slots().value != null;
        let hasTrendValue = ctx.props.trendValue != null || ctx.slots().trendValue != null;

        return h(
            'div', { class: ['wok--stats-card__wrapper', ctx.data.staticClass] }, [
                h('div', { class: 'wok--stats-card' }, [
                    h('div', { class: 'wok--stats-card__data' }, [
                        ctx.props.icon && h('i', { class: 'wok--stats-card__icon' }, [
                            h(ctx.props.icon)
                        ]),
                        h('div', { class: 'wok--stats-card__text' }, [
                            h('h5', { class: 'wok--stats-card__title' }, [
                                ctx.props.title || ctx.slots().title
                            ]),
                            h('div', { class: 'wok--stats-card__values' }, [
                                h('h3', { class: [
                                    'wok--stats-card__value',
                                    { 'wok--stats-card__value--highlight': hasFromValue && !ctx.props.icon }
                                ]}, [
                                    ctx.props.value || ctx.slots().value
                                ]),
                                hasFromValue && h('div', { class: 'wok--stats-card__from-value' }, [
                                    ctx.props.fromValue || ctx.slots().fromValue
                                ]),
                                hasTrendValue && h('div', { class: [
                                    'wok--stats-card__trend',
                                    { [`wok--stats-card__trend--${ctx.props.trend}`]: ctx.props.trend }
                                ]}, [
                                    appropriateTrendIcon(ctx) && h('i', { class: 'wok--stats-card__trend-icon' }, [
                                        h(appropriateTrendIcon(ctx))
                                    ]),
                                    h('span', { class: 'wok--stats-card__trend-value' }, [
                                        ctx.props.trendValue || ctx.slots().trendValue
                                    ])
                                ])
                            ])
                        ]),
                        ctx.slots().actions && h('div', { class: 'wok--stats-card__actions' }, [
                            ctx.slots().actions
                        ])
                    ])
                ])
            ]
        )
    }
}

function appropriateTrendIcon(ctx: RenderContext) {
    if (ctx.props.trend == 'increasing') {
        return 'wok-icon-up-sm-16';
    }
    else if (ctx.props.trend == 'decreasing') {
        return 'wok-icon-down-sm-16';
    }
    else {
        return '';
    }
}   